import { PageError } from 'models/PageError';
import { createReducer } from 'store/createReducer';
import {
  RESET_SERVER_RESPONSE_ERROR,
  SERVER_RESPONSE_ERROR,
  ServerResponseErrorAction
} from './actions';

export const initialState = {
  errorMessages: [],
  hasError: false
};

export default createReducer(initialState, {
  [SERVER_RESPONSE_ERROR]: (_: PageError, action: ServerResponseErrorAction) => {
    return {
      hasError: true,
      errorMessages: action.errorMessages
    };
  },
  [RESET_SERVER_RESPONSE_ERROR]: () => {
    return {
      hasError: false,
      errorMessages: []
    };
  }
});
